import styled from "styled-components";
import TextField from "@mui/material/TextField";

import { breakpoints } from "@/styles/breakpoints";

export const StyledConversationChat = styled.div<{ $disabled: boolean }>`
    box-sizing: border-box;
    width: calc(100% - 32px);
    padding: 8px 16px 8px 16px;
    margin-left: 32px;
    background-color: ${(props) => (props.$disabled ? "transparent" : "var(--color-white)")};
    border: 1px solid var(--color-grey-700);
    border-radius: var(--radius-10);
    @media ${breakpoints.xs} {
        width: 100%;
        margin-left: 0;
    }

    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible;
        border: 0;
        border-top: 1px solid var(--color-grey-700);
    }
`;

export const StyledConversationChatInput = styled(TextField)`
    border: none;
    color: var(--color-grey-900);
    width: 100%;

    .Mui-disabled {
        background-color: transparent;
    }

    .MuiInputBase-root {
        padding: 0;
    }

    .MuiOutlinedInput-notchedOutline {
        border: none;
    }
`;
